import Swiper, { Autoplay, EffectFade, Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';

function initializeBannerRecipes(containerId) {
    const containerSlider = $(containerId);
    const bannerRoot = containerSlider.closest('.banner-recipes');

    const bannerSlider = new Swiper(containerId, {
        modules: [Navigation, EffectFade, Autoplay],
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        spaceBetween: 30,
        slidesPerView: 1,
        loop: true,

        navigation: {
            prevEl: bannerRoot.find('.banner-recipes-nav .btn-prev')[0],
            nextEl: bannerRoot.find('.banner-recipes-nav .btn-next')[0],
        },

        autoplay: {
            delay: 7000,
        },

        on: {
            init: function () {
                this.slides.forEach(slide => slide.classList.remove('hidden'));

                const activeSlider = containerSlider.find('.swiper-slide-active');
                updateBannerRecipesSlideTheme(bannerRoot, activeSlider.data('color'));
            }
        }
    });

    bannerSlider.on('slideChangeTransitionEnd', function () {
        const activeSlider = containerSlider.find('.swiper-slide-active');
        const currentSlideImg = activeSlider.data('img');

        bannerRoot.find('.banner-recipes-image').attr('src', currentSlideImg);
        updateBannerRecipesSlideTheme(bannerRoot, activeSlider.data('color'));
    });
}

function updateBannerRecipesSlideTheme(bannerRoot, slideColor) {
    if (!slideColor) {
        return;
    }

    bannerRoot.find('.banner-recipes-color').css('background-color', slideColor);
    bannerRoot.css('--banner-recipes-slide-color', slideColor);
}

$('.banner-recipes-slider').each(function () {
    initializeBannerRecipes('#' + $(this).attr('id'));
});
